import { render, staticRenderFns } from "./SmsTemplateModal.vue?vue&type=template&id=32c4b0c3&scoped=true"
import script from "./SmsTemplateModal.vue?vue&type=script&lang=js"
export * from "./SmsTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./SmsTemplateModal.vue?vue&type=style&index=0&id=32c4b0c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c4b0c3",
  null
  
)

export default component.exports